<template>
    <div class="eva-item">
        <Header title="目标课程评价" type="0" route="/homeIndex" :casLogin="casLogin"></Header>
        <!----<div class="plhksq-search">
            <i class="search-icon"></i>
        <input type="text" placeholder="搜索课程(名称或课号)" v-model="kcxx" />
        </div>---->
        <div class="conditiondiv">
            <van-field
		  v-model="xnxq.xnxqmc"
		  label="学年学期"
		  right-icon="arrow"
		  input-align="right"
		  placeholder="请点击选择"
		  @click="showPop()"
		  readonly
		/></div>
        <NOdata v-if="evaluateList.length == 0" title="暂无评价数据~"></NOdata>
        <div class="evaluate_content">
            <div v-for="(item, index) in evaluateList" :key="index" @click="teachEva(item)">
                <div>
                    <h4>{{ item.kcmc }}[{{item.kch}}]</h4>
                    <p>上课老师：{{ item.skls }}</p>
                    <p>达成度：{{ item.wcd }}</p>
                    <p v-if="item.issave=='1'">评价状态：已评</p>
                    <p v-else>评价状态：<span style="color:red">未评</span></p>
                    <p v-if="item.issubmit=='1'">提交状态：已提交</p>
                    <p v-else>评价状态：<span style="color:red">未提交</span></p>
                </div>
                <span class="icon_right"></span>
            </div>
        </div>
        <van-popup v-model="show" round position="bottom">
		<van-picker
		  title="学年学期"
		  show-toolbar
		  :columns="xnxqColumList"
          :default-index="xnxqIndex"
		  @cancel="show = false"
		  @confirm="
			(value, index) => {
			  onConfirm(value, index);
			}
		  "
	  /></van-popup>
    </div>
</template>

<script>
import { Api } from '../../../utils/axios';
export default {
    data() {
        return {
            kcxx:'',
            xnxq:{xnxqmc:'',xnxqid:''},
            xnxqList:[],
            show:false,
            xnxqColumList:[],
            xnxqIndex:0,
            casLogin: sessionStorage.getItem('casLogin'),
            evaluateList: [],
        };
    },
    created() {
        this.getEvaluate();
    },
    methods: {
        async getEvaluate() {
            const params = {
                xnxq01id:this.xnxq.xnxqid
           };
            const res = await Api.getEvaluateGoalApi(params);
            this.evaluateList = res.data;
            if(res.xnxqdata){
                this.xnxqList = res.xnxqdata;
                for(let i=0;i<this.xnxqList.length;i++){
                    if(this.xnxqList[i].isdqxq=='1'){
                        this.xnxq.xnxqmc=this.xnxqList[i].semesterName;
                        this.xnxq.xnxqid=this.xnxqList[i].semesterId;
                        this.xnxqIndex = i;
                    }
                    this.xnxqColumList.push(this.xnxqList[i].semesterName);
                }
            }
        },
        showPop(){
            this.show=true;
        },
        onConfirm(value, index){
            let oldxnxqid = this.xnxq.xnxqid;
            this.xnxq.xnxqmc = this.xnxqList[index].semesterName;
            this.xnxq.xnxqid = this.xnxqList[index].semesterId;
            this.show = false;
            if(this.xnxq.xnxqid!=oldxnxqid){
                this.getEvaluate();
            }

        },
        teachEva(obj) {
            if(obj.timeflag=='0'){
                this.$toast("当前不在评教时间范围内！");
                return;
            }
            let p = '/student/teachEvaluateGoal';
            this.$router.push({
                path: p,
                query: {
                    dataObj: JSON.stringify(obj)
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.noticeDiv{
    height: 50px;
    position:fixed ;
    top: 50px;
    left: 0;
    right: 0;
    z-index: 999;
    padding-left: 20px;
    padding-right: 20px;
}
.evaluate_content{

}
.eva-item .evaluate_content {
    font-family: PingFangSC;
    padding: 20px;
    padding-top: 5px ;
}
.eva-item .evaluate_content > div {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: @attendance-background-color-10;
    padding: 10px 20px;
    box-sizing: border-box;
    color: @attendance-color-2;
    margin-bottom: 15px;
    border-radius: 5px;
    position: relative;
}
.eva-item .evaluate_content > div::after {
    position: absolute;
    content: '';
    background-color: @attendance-background-color-1;
    width: 3px;
    left: 0;
    border-radius: 5px 0 0 5px;
    height: 100%;
}
.eva-item .evaluate_content > div p {
    color: @attendance-color-2;
    font-size: 12px;
    line-height: 17px;
    margin-bottom: 2px;
}
.eva-item .evaluate_content > div h4 {
    color: @attendance-color-1;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 4px;
}
.eva-item .evaluate_content div .icon_right {
    height: 15px;
    width: 15px;
    background: url(../../../../static/img/arrow.png) center center no-repeat;
    background-size: contain;
}
/deep/.van-cell{
      padding: 10px 15%;
}

.plhksq-search {
  background-color: @attendance-background-color-6;
  border-radius: 3px;
  margin: 20px 20px 0;
  padding: 11px 12px;
  display: flex;
}
.search-icon {
  background: url(../../../../static/img/search.png) no-repeat center;
  width: 20px;
  height: 20px;
  background-size: 100%;
}
.plhksq-search input {
  background-color: @attendance-background-color-6;
  padding-left: 11px;
  flex: 1;
  color: @attendance-color-2;
}
</style>



// WEBPACK FOOTER //
// src/components/student/Evaluate/evaluateGoal.vue